import React, { useEffect, useState } from 'react'
import styles from "./ViewPropertyStyles/ViewPropertyStyle.module.scss"
import { useFormik } from 'formik'
import Swal from 'sweetalert2'
import { Get_Gst_Status, Get_PAN_GST, Update_Gst_Status, Update_PAN_GST } from '../Edit_Propetry/Edit_Propetry_Api'
import { CircularProgress } from '@mui/material'
import * as Yup from 'yup'

interface PANGSTCINNumberDataType {
    cin: string
    gstin: string
    pan: string
}

interface initialValuesDataType{
    gst_present: boolean 
    cin: string 
    gstin: string 
    pan: string
}

const panRegex = /^([A-Z]{5})(\d{4})([A-Z]{1})$/
const gstRegex = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/
const cinRegex = /^([LUu]{1})([0-9]{5})([A-Z]{2})([0-9]{4})([A-Z]{3})([0-9]{6})$/

const PropertyGSTDetails = ({ property_uuid }: { property_uuid: string }) => {
    const [loading, setLoading] = useState<boolean>(false)
    const [gstStatusLoading, setGstStatusLoading] = useState<boolean>(false)
    const [updateGSTDetails, setUpdateGSTDetails] = useState<boolean>(false)
    const [gstStatus, setGstStatus] = useState<boolean>(true)
    const [PANGSTCINNumber, setPANGSTCINNumber] = useState<PANGSTCINNumberDataType>({ cin: "", gstin: "", pan: "" })

    const PropertyGSTDetailsValidationSchema = Yup.object({
        cin: Yup.string().matches(cinRegex, 'Invalid CIN format').optional(),
        gstin: Yup.string().matches(gstRegex, 'Invalid GSTIN format').optional(),
        pan: Yup.string().matches(panRegex, 'Invalid PAN format').optional(),
    })

    const handleUpdateGstPanCin = async (values:initialValuesDataType) => {
        setLoading(true)
        try {
            const { data: res } = await Update_PAN_GST(
                property_uuid, formik.values.pan, formik.values.gstin, formik.values.cin
            )
            if (res.code === '200') {
                getPANGSTNumber()
                setUpdateGSTDetails(false)
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                    text: res.msg_details,
                    allowOutsideClick: true,
                })
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                    text: res.msg_details,
                    allowOutsideClick: true,
                })
            }
        }
        catch (error: any) {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error,
                allowOutsideClick: true,
            })
        }
        finally {
            setLoading(false)
        }
    }

    const formik = useFormik({
        initialValues: { gst_present: gstStatus, cin: PANGSTCINNumber.cin ? PANGSTCINNumber.cin : "", gstin: PANGSTCINNumber.gstin ? PANGSTCINNumber.gstin : "", pan: PANGSTCINNumber.pan ? PANGSTCINNumber.pan : "" },
        enableReinitialize: true,
        validationSchema: PropertyGSTDetailsValidationSchema,
        onSubmit: (values) => handleUpdateGstPanCin(values),
    })

    useEffect(() => {
        setLoading(true)
        const fetchData = async () => {
            try {
                await Promise.all([getGSTStatus(), getPANGSTNumber()])
            } catch (error: any) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error,
                })
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [])

    const getPANGSTNumber = async () => {
        try {
            const { data: res } = await Get_PAN_GST(
                property_uuid
            )
            if (res.code === '200') {
                setPANGSTCINNumber(res.data)
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                    text: res.msg_details,
                    allowOutsideClick: true,
                })
            }
        }
        catch (error: any) {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error,
                allowOutsideClick: true,
            })
        }
    }

    const getGSTStatus = async () => {
        try {
            const { data: res } = await Get_Gst_Status(
                property_uuid
            )
            if (res.code === '200') {
                setGstStatus(res.data.invoice_gst_applicable)
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                    text: res.msg_details,
                    allowOutsideClick: true,
                })
            }
        }
        catch (error: any) {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error,
                allowOutsideClick: true,
            })
        }
    }

    const handleGSTChange = async (GSTStatus: boolean) => {
        setGstStatusLoading(true)
        try {
            const { data: res } = await Update_Gst_Status(
                property_uuid,
                GSTStatus
            )
            if (res.code === '200') {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                    text: res.msg_details,
                    allowOutsideClick: true,
                })
                getGSTStatus()
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                    text: res.msg_details,
                    allowOutsideClick: true,
                })
            }
        }
        catch (error: any) {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error,
                allowOutsideClick: true,
            })
        }
        finally {
            setGstStatusLoading(false)
        }
    }

    return (
        <>
            {loading ? (
                <div
                    className='card mb-6 mb-xl-10 d-flex justify-content-center align-items-center vh-70'
                    style={{ height: '70vh' }}
                >
                    <CircularProgress />
                </div>
            ) : (
                <div className='card mb-6 mb-xl-10'>
                    <div className='card-header d-flex justify-content-between align-items-center'>
                        {/* Begin: Heading agreement */}
                        <div className='card-title m-0'>
                            <h3 className='fw-bold m-0'>GST Details</h3>
                        </div>
                        {/* End: Heading agreement */}

                        <div className='d-flex flex-column pt-3'>
                            {/* Begin: Update GST Details button */}
                            {
                                (PANGSTCINNumber.cin || PANGSTCINNumber.gstin || PANGSTCINNumber.pan) &&
                                <>
                                    {
                                        updateGSTDetails ?
                                            <button
                                                className='btn btn-sm btn-light fw-bold bg-color-white shadow me-4 btn-active-light-primary'
                                                onClick={() => setUpdateGSTDetails(false)}
                                            >
                                                Cancel
                                            </button>
                                            :
                                            <button
                                                onClick={() => setUpdateGSTDetails(true)}
                                                className='align-self-center btn btn-sm btn-primary me-3'
                                            >
                                                Update GST Details
                                            </button>
                                    }
                                </>
                            }
                            {/* End: Update GST Details button */}
                        </div>
                    </div>
                    <div className='card-body p-9 row align-item-center'>
                        <form onSubmit={formik.handleSubmit} className='form'>
                            <div className='col-md-6 ms-4'>
                                <div className='row mb-6'>
                                    <label className='col-lg-6 fw-bold text-muted mt-1 mb-2'>Do property have GST?</label>
                                    {gstStatusLoading ?
                                        <div className='col-lg-6'>
                                            <CircularProgress style={{ height: "25px", width: "25px" }} />
                                        </div>
                                        :
                                        <div className='col-lg-6'>
                                            <label className={`${styles.switch}`}>
                                                <input type="checkbox" {...formik.getFieldProps('gst_present')}
                                                    name='gst_present' checked={gstStatus} onClick={(e) => handleGSTChange((e.target as HTMLInputElement).checked)} />
                                                <span className={`${styles.slider} ${styles.round}`}></span>
                                            </label>
                                            <span className='fw-bold fs-6 pt-3 ms-4'>
                                                {gstStatus ? "Yes" : "No"}
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>

                            {(!PANGSTCINNumber.cin && !PANGSTCINNumber.gstin && !PANGSTCINNumber.pan) || updateGSTDetails ?
                                <>
                                    {/* Begin: form field GST Number */}
                                    <div className='row mb-2 ms-2'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span>GST Number</span>
                                            <i
                                                className='fas fa-exclamation-circle ms-2 fs-7'
                                                data-bs-toggle='tooltip'
                                                title='Specify GST number'
                                            ></i>
                                        </label>
                                        <div className='col-lg-8 fv-row'>
                                            <input
                                                type='text'
                                                className='form-control form-control-lg form-control-solid'
                                                placeholder='Enter GST number'
                                                {...formik.getFieldProps('gstin')}
                                            />
                                            <div className='h-20px'>
                                                {formik.touched.gstin && formik.errors.gstin && (
                                                    <div className='fv-help-block color-red'>
                                                        {formik.errors.gstin.toString()}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* End: form field GST Number */}
                                    {/* Begin: form field PAN Number */}
                                    <div className='row mb-2 ms-2'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span>PAN Number</span>
                                            <i
                                                className='fas fa-exclamation-circle ms-2 fs-7'
                                                data-bs-toggle='tooltip'
                                                title='Specify PAN number'
                                            ></i>
                                        </label>
                                        <div className='col-lg-8 fv-row'>
                                            <input
                                                type='text'
                                                className='form-control form-control-lg form-control-solid'
                                                placeholder='Enter PAN number'
                                                {...formik.getFieldProps('pan')}
                                            />
                                            <div className='h-20px'>
                                                {formik.touched.pan && formik.errors.pan && (
                                                    <div className='fv-help-block color-red'>
                                                        {formik.errors.pan.toString()}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* End: form field PAN Number */}
                                    {/* Begin: form field CIN Number */}
                                    <div className='row mb-2 ms-2'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span>CIN Number</span>
                                            <i
                                                className='fas fa-exclamation-circle ms-2 fs-7'
                                                data-bs-toggle='tooltip'
                                                title='Specify CIN number'
                                            ></i>
                                        </label>
                                        <div className='col-lg-8 fv-row'>
                                            <input
                                                type='text'
                                                className='form-control form-control-lg form-control-solid'
                                                placeholder='Enter CIN number'
                                                {...formik.getFieldProps('cin')}
                                            />
                                            <div className='h-20px'>
                                                {formik.touched.cin && formik.errors.cin && (
                                                    <div className='fv-help-block color-red'>
                                                        {formik.errors.cin.toString()}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* End: form field CIN Number */}
                                    <div className='d-flex justify-content-center mx-auto my-2 mt-5'>
                                        <button
                                            type='submit'
                                            className='btn btn-sm btn-primary shadow'
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <span className='indicator-progress' style={{ display: 'block' }}>
                                                    Processing...
                                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                </span>
                                            ) : (
                                                <span> Update GST Details </span>
                                            )}
                                        </button>
                                    </div>
                                </>
                                :
                                <div className='col-md-6 ms-4'>
                                    {/* Begin: Detail field GST Number */}
                                    <div className='row mb-6'>
                                        <label className='col-lg-6 fw-bold text-muted'>GST Number</label>
                                        <div className='col-lg-6'>
                                            <span className='fw-bold fs-6 pb-1'>
                                                {PANGSTCINNumber.gstin ? PANGSTCINNumber.gstin : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    {/* End: Detail field GST Number */}
                                    {/* Begin: Detail field PAN Number */}
                                    <div className='row mb-6'>
                                        <label className='col-lg-6 fw-bold text-muted'>PAN Number</label>
                                        <div className='col-lg-6'>
                                            <span className='fw-bold fs-6 pb-1'>
                                                {PANGSTCINNumber.pan ? PANGSTCINNumber.pan : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    {/* End: Detail field PAN Number */}
                                    {/* Begin: Detail field CIN Number */}
                                    <div className='row mb-6'>
                                        <label className='col-lg-6 fw-bold text-muted'>CIN Number</label>
                                        <div className='col-lg-6'>
                                            <span className='fw-bold fs-6 pb-1'>
                                                {PANGSTCINNumber.cin ? PANGSTCINNumber.cin : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    {/* End: Detail field CIN Number */}
                                </div>
                            }
                        </form>
                    </div>
                </div>
            )
            }
        </>
    )
}

export default PropertyGSTDetails